import './prism-manual.js';
import Prism from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-smarty';
import 'prismjs/components/prism-twig';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-http';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-graphql';
import 'prismjs/components/prism-python';
import { $$ } from './util.js';

/* SYNTAX HIGHLIGHTING for code samples
   --------------------------------------------------------------------------
   Only blocks that say what they are get highlighted: a <code> carrying a
   language-* class, which components/hub-template-code.html (language-smarty,
   language-twig) and components/hub-code.html (language-<its language area>)
   emit. Code pasted into a Richtext area has no class and is left as it is.
   The languages bundled are the ones the guides use (2026-10-15): Smarty,
   Twig, HTML, PHP, JavaScript, JSON, shell, HTTP, CSS, SCSS, YAML, GraphQL, and
   Python for the API examples (js/api-example.js). A
   block in any other language keeps its label and is shown unhighlighted.

   Smarty and Twig are tokenised through markup-templating, so the template
   tags inside a block of HTML come out as their own islands (.token.smarty,
   .token.twig) and a variable no longer reads as part of the markup.
   The colours are in scss/components/_code.scss. */
export function initCodeHighlight() {
	$$('.article-body pre code[class*="language-"]').forEach(function (code) {
		Prism.highlightElement(code);
	});
}
